import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsBestsellerSliderBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsBestsellerSliderBlockEntity
